<template>
    <div class="">
        <div class=" flex-col flex gap-3 mt-3 text-gray-500 text-sm font-normal subpixel-antialiased font-sans">
            <p class="text-justify text-gray-500">Dear {{ (user.first_name).trim()}},</p>
            <p class="text-justify" v-html="reductionStatement"></p>
            <div class="flex flex-col gap-1">
                <p class="text-justify">Sincerely</p>
                <div v-html="signature"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['user','signature', 'reduction-statement'],
    data() {
        return {

        }
    },
    created() {
    },
    methods: {
    }
}
</script>
